import { IconProps } from "@/types/types";

export default function Check({ width = "24", height = "24" }: IconProps) {
    return (
        <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.1554 7.12211C21.4772 6.6379 21.4258 5.97839 20.9999 5.54996C20.5133 5.06032 19.7218 5.05792 19.2322 5.54459L8.97695 15.7377L4.76769 11.5561C4.27794 11.0695 3.48649 11.0721 2.99994 11.5619C2.76566 11.7977 2.64479 12.1035 2.63711 12.4115C2.63657 12.4333 2.63659 12.4551 2.63718 12.4769C2.64559 12.7867 2.76852 13.094 3.00574 13.3296L8.09619 18.3867C8.58376 18.8711 9.37092 18.871 9.85837 18.3865L20.9946 7.31772C21.0558 7.25688 21.1094 7.19129 21.1554 7.12211Z" fill="currentColor" />
        </svg>
    )
}

